import React, { Component } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import "./NavBar.css";
import { Link } from 'react-router-dom';

class NavBar extends Component {
    render() {
        return (
            <div>
                <Navbar bg = "light" expand="lg"> 
                    <Navbar.Brand as={Link} to="/">
                    <img src={process.env.PUBLIC_URL + '/char.png'} alt="Charlotte Logo" width="30" />Charlotte McKnight
                    </Navbar.Brand>                   
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav>
                            <Nav.Link as={Link} to="/projects">Projects</Nav.Link>
                            <Nav.Link as={Link} to="/skills">Skills</Nav.Link>
                            <Nav.Link as={Link} to="/about">About</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </div>
        );
    }
}

export default NavBar;